<template>
  <i v-if="iconfontClass" :class="['crmeb-menu-icon', 'iconfont', iconfontClass]" />
  <el-icon v-else-if="iconComponent" class="crmeb-menu-icon">
    <component :is="iconComponent" />
  </el-icon>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  getCrmebIconfontClass,
  resolveCrmebIconComponent,
} from '@/utils/crmebElementIcon';

const props = defineProps<{ icon?: string }>();

const iconfontClass = computed(() => getCrmebIconfontClass(props.icon));
const iconComponent = computed(() => resolveCrmebIconComponent(props.icon));
</script>

<style scoped>
/* 与 element-ui.scss 侧栏图标槽一致：宽 24 + 右距 5（对齐 EB） */
.crmeb-menu-icon {
  margin-right: 5px;
  font-size: 14px;
  vertical-align: middle;
}
</style>
